import { HandCoins, LifeBuoy, ShieldCheck, TrendingUp, Sunrise, Users, CircleCheck } from "lucide-react";

export const STATUT = [
  { value: "autonome", label: "Travailleur autonome non incorporé" },
  { value: "incorpore", label: "Travailleur incorporé / Société incorporée" },
  { value: "salarie", label: "Salarié" },
];
export const ANCIENNETE = [
  { value: "moins2", label: "Moins de 2 ans" },
  { value: "2a5", label: "2 à 5 ans" },
  { value: "5a10", label: "5 à 10 ans" },
  { value: "plus10", label: "Plus de 10 ans" },
  { value: "na", label: "Non applicable (salarié)" },
];
export const BENEFICE = [
  { value: "moins5k", label: "Moins de 5 000 $" },
  { value: "5a10k", label: "5 000 $ à 10 000 $" },
  { value: "10a20k", label: "10 000 $ à 20 000 $" },
  { value: "plus20k", label: "Plus de 20 000 $" },
];
export const EMPLOYES = [
  { value: "oui", label: "Oui" },
  { value: "non", label: "Non" },
];
export const OBJECTIF = [
  { value: "impot", label: "Réduire mon impôt" },
  { value: "croissance", label: "Faire croître mon entreprise" },
  { value: "proteger", label: "Protéger mes revenus" },
  { value: "retraite", label: "Préparer ma retraite" },
  { value: "epargner", label: "Épargner et investir" },
  { value: "autre", label: "Autre" },
];

export const FIELD_OPTIONS = { statut: STATUT, anciennete: ANCIENNETE, benefice: BENEFICE, employes: EMPLOYES, objectif: OBJECTIF };
export const FIELD_LABELS = {
  statut: "Statut professionnel", anciennete: "Années en affaires", benefice: "Bénéfice / revenu net mensuel",
  employes: "5 employés ou plus", objectif: "Objectif principal", secteur: "Secteur (slug)", metier: "Métier (slug)",
};
export const labelOf = (field, value) => FIELD_OPTIONS[field]?.find((o) => o.value === value)?.label || value;

const ICONS = {
  "Remplacement de revenu": HandCoins,
  "Fonds d'urgence": LifeBuoy,
  "Placement garanti": ShieldCheck,
  "Capital entrepreneurial": TrendingUp,
  "Stratégie de retraite libre d'impôt": Sunrise,
  "Fidélité corporative": Users,
};
export const componentIcon = (name) => ICONS[name] || CircleCheck;

export const DISCLAIMER =
  "Cette suggestion est informative et préliminaire. Elle ne constitue pas une recommandation financière personnalisée. Une analyse complète de votre situation est nécessaire avant toute recommandation de produit ou de stratégie.";

export const isValidPhone = (v) => {
  const d = (v || "").replace(/\D/g, "").replace(/^1(?=\d{10}$)/, "");
  return d.length === 10 && !"01".includes(d[0]);
};
export const formatPhone = (v) => {
  const d = (v || "").replace(/\D/g, "").replace(/^1/, "").slice(0, 10);
  if (d.length < 4) return d;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};
export const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v || "");
